module.exports = __webpack_public_path__ + "images/emoji/incoming_envelope.2ca6f59be867535bd4bb.png";